var exports = {
  "I$": "xfd349460--906346--compilation",
  "Kk": "xfd349460--906346--icon",
  "UE": "xfd349460--906346--arrow",
  "Qs": "xfd349460--906346--content",
  "DD": "xfd349460--906346--title",
  "Nu": "xfd349460--906346--no-wrap",
};

module.exports = exports;
